
      import ImportList from './import-list.vue'
      import type { App, Plugin } from 'vue'

      export const ImportListPlugin: Plugin = {
        install(app: App) {
          app.component('ImportList', ImportList)
        },
      }
      export { ImportList }
      